const kpiList = {
  kpiTQF: [
    {
      id: "tqf01",
      value: "tqf01",
      name: "ผลสำเร็จของการนำความรู้และประสบการณ์จากการบริการวิชาการมาใช้พัฒนาการเรียนการสอน",
    },
    {
      id: "tqf02",
      value: "tqf02",
      name: "ผลสำเร็จของการทำนุบำรุงศิลปวัฒนธรรม",
    },
    { id: "tqf03", value: "tqf03", name: "จัดการเรียนการสอน Online" },
    {
      id: "tqf04",
      value: "tqf04",
      name: "จัดการเรียนการสอนแบบ Active learning หรือ Coaching",
    },
    {
      id: "tqf05",
      value: "tqf05",
      name: "มีการนำโครงการฯ ขยายผลสู่การปรับปรุงเนื้อหาของหน่วยเรียนในรายวิชา",
    },
    {
      id: "tqf06",
      value: "tqf06",
      name: "มีการบูรณาการจัดการเรียนการสอนกับเทคโนโลยีและนวัตกรรม",
    },
    {
      id: "tqf07",
      value: "tqf07",
      name: "รูปแบบการจัดการเรียนการสอนโดยใช้สื่อเสมือนจริง",
    },
    {
      id: "tqf08",
      value: "tqf08",
      name: "รูปแบบการจัดการเรียนรู้โดยอิงประสบการณ์",
    },
    {
      id: "tqf09",
      value: "tqf09",
      name: "รูปแบบการจัดการเรียนรู้โดยใช้เทคนิคการเสริมแรง",
    },
    {
      id: "tqf10",
      value: "tqf10",
      name: "บูรณาการการเรียนการสอนร่วมกับการวิจัย",
    },
    {
      id: "tqf11",
      value: "tqf11",
      name: "บูรณาการการเรียนการสอนร่วมกับการบริการวิชาการทางสังคม",
    },
    {
      id: "tqf12",
      value: "tqf12",
      name: "บูรณาการการเรียนการสอนร่วมกับการทำนุบำรุงศิลปและวัฒนธรรม",
    },
  ],
  kpiMhesi: [
    {
      id: "Mhesi01",
      value: "Mhesi01",
      name: "รูปแบบการจัดการเรียนรู้โดยอิงประสบการณ์",
    },
    {
      id: "Mhesi02",
      value: "Mhesi02",
      name: "รูปแบบการจัดการเรียนรู้โดยใช้เทคนิคการเสริมแรง",
    },
  ],
};
export default kpiList;
